import { eBienLaiViewActionsObj } from "../../action-types/bien-lai/IBienLaiViewActionTypes";
import { generateActions } from "../generateActions";

export const bienLaiViewActions = {
  ...generateActions(eBienLaiViewActionsObj, "BIEN_LAI_VIEW"),
};
